const md = `# Troubleshooting

## A step failed mid-run

Click the step row in the run-detail page's step list — it expands to
show the exact selector, the strategy chain Playwright tried (css →
testId → label → role → text), and the underlying error message.  The
screenshot taken *just before* the failure is also linked.

If the step has \`continue_on_failure=True\` (most non-critical
steps), the run still completes — but the affected feature won't
appear in the final state.  Look at the run's *completed_steps* vs
*total_steps* — 41/44 means three soft failures.

## The Eyvo UI changed and now everything's broken

Every line-item workflow includes **\`evaluate_js\` discovery steps**
that dump the current DOM state to
\`/app/backend/storage/runs/<run_id>/discovery/\`.  Open the latest
run's discovery folder, find the \`.json\` for the broken section, and
use the dump to write new selectors.

Two specific dumps are always produced for the free-form workflow:

1. \`33_DISCOVERY_enumerate_popover_menuitems.json\` — what's in the
   "Actions" popover.
2. \`37_DISCOVERY_enumerate_freeform_dialog_inputs_buttons.json\` — the
   New Item dialog's inputs (with inferred labels), textareas,
   selects, and buttons (with their exact text + disabled state).

Once you have the new selectors, update \`/app/backend/services/seed_v5.py\`
and rerun \`scripts/promote_seed_v5_v3.py\` to publish a new immutable
version.

## Narration generated but the voiceover panel says "pending" forever

Almost always the ElevenLabs API key is missing or out of balance.
Open \`/var/log/supervisor/backend.err.log\` and grep for
\`elevenlabs\`.  Add the key to \`/app/backend/.env\` and
\`sudo supervisorctl restart backend\`.

## The MP4 looks fine but the audio is 2 seconds shorter than the video

The ffmpeg stitcher pads silence to the end of the audio track when
the voiceover is shorter than the video.  If the audio is *longer*
than the video, the MP4's length is extended with a freeze-frame on
the last screenshot.  Either way, the file is playable in every
modern player.

## A workflow I edited won't show up in the run modal

Editing creates a new version.  The library always points at the
latest version — but the **Run** button uses the workflow's
\`current_version\`, which is bumped automatically on save.  If you're
still seeing the old steps, hard-refresh the page (Cmd+Shift+R).

## Auth quirks

* If you're a Viewer and a button you expected to see is missing, your
  role doesn't permit that action.  Ask an admin to promote you.
* If your token expired, you'll be silently redirected to the Login
  page.  Re-auth and you're back where you were.
`;

export default md;
